// extracted by mini-css-extract-plugin
export default {"button":"Ep-z","reviewSort":"Fp-z"};